import React, { useState } from 'react';
import '../../../styles/admin/manager.css';
import { Link, useNavigate } from 'react-router-dom';
import { RiFileExcel2Fill } from "react-icons/ri";
import * as XLSX from 'xlsx';

const OptionAgent = () => {

    const [selectedOption, setSelectedOption] = useState('manager');
    const navigate = useNavigate();

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedOption(event.target.value);
        navigate(`${selectedValue}`);
    };

    const exportToExcel = () => {
        const input = document.querySelector('.info-weekly') as HTMLElement;
        if (input) {
            const tableClone = input.cloneNode(true) as HTMLElement;
            const rows = tableClone.querySelectorAll('.player-row') as NodeListOf<HTMLElement>;
            rows.forEach(row => row.remove());

            const ws = XLSX.utils.table_to_sheet(tableClone);

            ws['!cols'] = [
                { wpx: 90 },

            ];

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, 'report.xlsx');
        } else {
            console.error("Item not found: .info-weekly");
        }
    };

    return (
        <>
            <div className='container-manager mt-1 justify-content-end'>
                <div className='align-items-center'>
                    {(selectedOption === 'accounting' || selectedOption === 'detailed') && (
                        <>
                            <select id='lastWeek' name='lastWeek' className='option-week'>
                                <option value="manager">Last Week</option>
                            </select>
                            {selectedOption === 'accounting' && (
                                <button type="button" className='buttonSetting' onClick={exportToExcel}><RiFileExcel2Fill /></button>
                            )}
                        </>
                    )}
                </div>
                <div className='option-manager'>
                    <Link to="/register-an-agent" className=' no-link'>
                       Add new Agent

                    </Link>
                    {/* <select id='select-agent' name='selectagent' className='option-manager' onChange={handleSelectChange} >
                        <option value="manager">Agent Management</option>
                        <option value="accounting">Accounting</option>
                        <option value="detailed">Detailed Accounting</option>
                    </select> */}
                </div>
            </div>
        </>
    )
}

export default OptionAgent;